import React, { useState } from 'react';
import {
    TextField,
    Paper,
    Button,
    IconButton,
    Box
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import SubmitIcon from '@mui/icons-material/Check';
import {isMobile} from "../App/utils.js";

export const JSONGrid = ({ initialData, translations }) => {
    const [data, setData] = useState(initialData);

    const handleChange = (event, rowIndex, key) => {
        const newData = [...data];
        newData[rowIndex][key] = event.target.value;
        setData(newData);
    };

    if (!data[0]) {
        return null;
    }

    return (
        <Box sx={{ width: '100%', marginTop: '24px' }}>
            {data.map((row, rowIndex) => (
                <Paper sx={{ display: 'flex', flexDirection: ['column', 'row'], gap: '10px', p: 2, mb: 2 }} key={rowIndex}>
                    {Object.entries(row).map(([key, value]) => {
                        let width = (value && value.length) ? (value.length * 10) : 100;
                        // if (isMobile) width = 100;
                        return (
                            <Box key={key} sx={{ flex: 1 }} >
                                <TextField
                                    multiline={true}
                                    label={translations?.[key] || key}
                                    value={value || ''}
                                    fullWidth
                                    onChange={(event) => handleChange(event, rowIndex, key)}
                                    size="small"
                                    inputProps={{ }}
                                />
                            </Box>
                        )
                    })}
                    {/*<IconButton edge="end" aria-label="delete" onClick={() => handleDeleteRow(rowIndex)}>*/}
                    {/*    <DeleteIcon />*/}
                    {/*</IconButton>*/}
                </Paper>
            ))}
            {/*<Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2, marginBottom: '20px' }}>*/}
            {/*    <Button onClick={() => {}}><SubmitIcon sx={{mr: 1}} />Insert</Button>*/}
            {/*    <Button onClick={handleAddRow}><AddIcon sx={{mr: 1}} />Add Row</Button>*/}
            {/*</Box>*/}
        </Box>
    );
};
